import { render, staticRenderFns } from "./ServiceCZNNewDialog.vue?vue&type=template&id=2620cc10"
import script from "./ServiceCZNNewDialog.vue?vue&type=script&lang=js"
export * from "./ServiceCZNNewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports